import z from 'zod';

export const PriceSchema = z.object({
  amount: z.number(),
  currencyCode: z.string(),
  prefix: z.string().optional(),
  suffix: z.string().optional(),
});

export const ImageSchema = z
  .object({
    externalKey: z.string().optional(),
    external_key: z.string().optional(),
    url: z.string(),
  })
  .refine((data) => data.externalKey || data.external_key, {
    message: 'Either externalKey or external_key must be provided',
  });

export const VoucherBaseSchema = z.object({
  id: z.number(),
  uuid: z.string().optional(),
  code: z.string(),
  redemptionTotal: PriceSchema,
  redemptionDueDate: z.string().optional(),
  redemptionId: z.string().optional(),
  redeemedAt: z.string().optional(),
  name: z.string().optional(),
});

export const ExperienceVoucherSchema = VoucherBaseSchema.extend({
  orderItem: z.union([z.number(), z.string()]).nullish(),
  basketItem: z.union([z.number(), z.string()]).nullish(),
});

export const MonetaryVoucherSchema = VoucherBaseSchema;

export const VoucherSchema = z.union([ExperienceVoucherSchema, MonetaryVoucherSchema]);

export const ExperienceVoucherNormalizedSchema = ExperienceVoucherSchema.transform((data) => ({
  ...data,
  itemId: data.basketItem ?? data.orderItem,
}));
